import React from 'react'

const CreditCardGreenSvg = ({ width }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} viewBox='0 0 20 15'>
      <g
        id='credit-card-svgrepo-com_2_'
        data-name='credit-card-svgrepo-com (2)'
        transform='translate(0 -8)'
      >
        <path
          id='Path_3180'
          data-name='Path 3180'
          d='M0,32v6.25A1.249,1.249,0,0,0,1.25,39.5h17.5A1.249,1.249,0,0,0,20,38.25V32Zm7.5,3.75H5a1.25,1.25,0,0,1,0-2.5H7.5a1.25,1.25,0,0,1,0,2.5Z'
          transform='translate(0 -16.5)'
          fill='#b5ccc2'
        />
        <path
          id='Path_3181'
          data-name='Path 3181'
          d='M20,13V9.25A1.249,1.249,0,0,0,18.75,8H1.25A1.249,1.249,0,0,0,0,9.25V13Z'
          fill='#b5ccc2'
        />
      </g>
    </svg>
  )
}

export default CreditCardGreenSvg
